/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export function focus(elementOrRef) {
  var element = elementOrRef.current || elementOrRef;

  if (element && element.focus && document.activeElement !== element) {
    element.focus();
  }
}